import VentanaCaducidadContainer from './containers/ventana-caducidad-container';
export default VentanaCaducidadContainer;